/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".custom-atc-wrapper").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();

      const formData = new FormData(form);

      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json"
        }
      })
      .then(response => response.json())
      .then(() => {
        // Refresh the Broadcast cart
        if (window.cart && typeof window.cart.getCart === "function") {
          window.cart.getCart();
        }

        // Open the cart drawer
        if (window.cart && typeof window.cart.openCartDrawer === "function") {
          window.cart.openCartDrawer();
        }
      })
      .catch(error => {
        console.error("Add to cart failed:", error);
      });
    });
  });
});

  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
